// Mock data for Prism application

export interface Stock {
  id: string;
  code: string;
  name: string;
  topic?: string;
  change: number;
  changePercent: number;
  rps10?: number;
  rps20?: number;
  rps50?: number;
  rps120?: number;
  rps250?: number;
  signalDate?: string;
  dataDate: string;
}

export interface Signal {
  id: string;
  stock: Stock;
  signalType: string;
  signalStrength: number; // 1-5 stars
  category: 'oneil' | 'magic';
}

export interface CombinedSignal {
  id: string;
  stock: Stock;
  signalTypes: string[];
  signalStrength: number;
}

// Generate mock stock data
export const mockStocks: Stock[] = [
  {
    id: '1',
    code: '600519',
    name: '贵州茅台',
    topic: '白酒',
    change: 25.8,
    changePercent: 1.45,
    rps20: 95,
    rps10: 92,
    rps50: 88,
    rps120: 85,
    rps250: 82,
    signalDate: '2026-02-12',
    dataDate: '2026-02-14'
  },
  {
    id: '2',
    code: '000858',
    name: '五粮液',
    topic: '白酒',
    change: -12.5,
    changePercent: -0.68,
    rps20: 78,
    rps10: 81,
    rps50: 75,
    rps120: 72,
    rps250: 70,
    signalDate: '2026-02-13',
    dataDate: '2026-02-14'
  },
  {
    id: '3',
    code: '601318',
    name: '中国平安',
    topic: '保险',
    change: 8.3,
    changePercent: 0.52,
    rps20: 88,
    rps10: 85,
    rps50: 82,
    rps120: 79,
    rps250: 76,
    signalDate: '2026-02-11',
    dataDate: '2026-02-14'
  },
  {
    id: '4',
    code: '300750',
    name: '宁德时代',
    topic: '新能源',
    change: 45.2,
    changePercent: 2.15,
    rps20: 98,
    rps10: 96,
    rps50: 94,
    rps120: 91,
    rps250: 88,
    signalDate: '2026-02-14',
    dataDate: '2026-02-14'
  },
  {
    id: '5',
    code: '002594',
    name: '比亚迪',
    topic: '新能源',
    change: 32.1,
    changePercent: 1.82,
    rps20: 93,
    rps10: 91,
    rps50: 89,
    rps120: 86,
    rps250: 83,
    signalDate: '2026-02-13',
    dataDate: '2026-02-14'
  },
  {
    id: '6',
    code: '600036',
    name: '招商银行',
    topic: '银行',
    change: -5.2,
    changePercent: -0.35,
    rps20: 72,
    rps10: 75,
    rps50: 71,
    rps120: 68,
    rps250: 65,
    signalDate: '2026-02-10',
    dataDate: '2026-02-14'
  },
  {
    id: '7',
    code: '000333',
    name: '美的集团',
    topic: '家电',
    change: 15.6,
    changePercent: 1.12,
    rps20: 85,
    rps10: 83,
    rps50: 80,
    rps120: 77,
    rps250: 74,
    signalDate: '2026-02-12',
    dataDate: '2026-02-14'
  },
  {
    id: '8',
    code: '600900',
    name: '长江电力',
    topic: '水电',
    change: 6.8,
    changePercent: 0.42,
    rps20: 80,
    rps10: 78,
    rps50: 76,
    rps120: 74,
    rps250: 72,
    signalDate: '2026-02-11',
    dataDate: '2026-02-14'
  }
];

// Generate mock signals
export const mockSignals: Signal[] = [
  {
    id: 's1',
    stock: mockStocks[0],
    signalType: '口袋支点',
    signalStrength: 5,
    category: 'oneil'
  },
  {
    id: 's2',
    stock: mockStocks[1],
    signalType: '三线翻红',
    signalStrength: 3,
    category: 'oneil'
  },
  {
    id: 's3',
    stock: mockStocks[3],
    signalType: '一年新高',
    signalStrength: 5,
    category: 'oneil'
  },
  {
    id: 's4',
    stock: mockStocks[4],
    signalType: '净利润断层',
    signalStrength: 4,
    category: 'magic'
  },
  {
    id: 's5',
    stock: mockStocks[6],
    signalType: '口袋支点',
    signalStrength: 4,
    category: 'oneil'
  }
];
